import { useDispatch, useSelector } from 'react-redux';
import { getCopiedRadioField } from '../helper';
import { v4 as uuidv4 } from 'uuid';
import {
  deleteDynamicFormQuestionEffect,
  modifyQuestionPageEffect,
  selectDynamicFormFieldEffect,
  updateDynamicFormQuestionEffect,
} from 'store/effects/formProcess';
import { DYNAMIC_QUESTION_TYPE } from 'app-constants';
import { DynamicFormSelectedField } from 'types';
import { getDynamicFormEditorConfigSelector } from 'store/selectors/requestFormProcess';
import { DefaultSystemFont, SignatureResponseType } from 'pages/FormBuilder/components';

export const useManageFieldActions = (props) => {
  const { field, height, index, role, fieldActionProps, documentIndex, isTemplate } = props;
  const dispatch = useDispatch();

  const isGroupField = field.type === DYNAMIC_QUESTION_TYPE.RadioGroup;
  const isFullName = field.type === DYNAMIC_QUESTION_TYPE.FullName;
  const { selectedField, selectedFieldIndex } = useSelector(getDynamicFormEditorConfigSelector);

  const makeFieldCopy = () => {
    let updatedField: any = { ...field };
    if (isGroupField) {
      updatedField = getCopiedRadioField(updatedField);
    }

    const newField = {
      ...updatedField,
      isNew: true,
      UUID: uuidv4(),
      y: updatedField.y + height + (isGroupField ? -50 : 6),
      ...fieldActionProps,
      ...(isGroupField && { isNewGroup: true }),
    };

    delete newField.id;
    delete newField.order;
    delete newField.isUpdated;

    if (isFullName && !isTemplate) {
      const data = {
        fullName: newField.customRole.roleName,
        type: SignatureResponseType.Text,
        font: DefaultSystemFont,
      };

      newField.fieldAnswer = {
        answer: JSON.stringify(data),
        UUID: newField.UUID,
        fontSize: 12,
        documentIndex,
      };
    } else {
      delete newField.fieldAnswer;
    }

    dispatch(updateDynamicFormQuestionEffect(newField));
  };

  const onDeleteField = () => {
    dispatch(
      deleteDynamicFormQuestionEffect({
        ...field,
        index,
        ...fieldActionProps,
      }),
    );
  };

  const handleFieldUpdate = (updatedProps) => {
    dispatch(
      updateDynamicFormQuestionEffect({
        ...field,
        index,
        ...updatedProps,
        ...fieldActionProps,
        ...props.viewModeProps,
      }),
    );
  };

  const handleFieldRequired = (e) => {
    if (selectedField) {
      handleFieldUpdate({ ...selectedField, index: selectedFieldIndex, required: e });
    }
  };

  const handleHighLightField = () => {
    if (isGroupField) return;

    const { pageNumber, roleName, UUID } = field;
    dispatch(
      selectDynamicFormFieldEffect({
        field: {
          pageNumber,
          roleName,
          UUID,
          roleId: role?.roleId,
        } as DynamicFormSelectedField,
      }),
    );
  };

  const manageOtherPageFieldDrag = (updatedProps) => {
    const { documentIndex, ...restActionProps } = fieldActionProps;
    dispatch(
      modifyQuestionPageEffect({
        ...field,
        index,
        ...updatedProps,
        ...restActionProps,
      }),
    );
  };

  return {
    makeFieldCopy,
    onDeleteField,
    handleFieldUpdate,
    handleFieldRequired,
    handleHighLightField,
    manageOtherPageFieldDrag,
  };
};
